var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.display)?_c('apexchart',{attrs:{"type":"line","height":500,"options":_vm.chartOptions,"series":_vm.series}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }